import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import CanDelete from '@/shared/components/security/CanDelete';
import CanUpdate from '@/shared/components/security/CanUpdate';
import messages from '../taskMessages';
import AuthService, { functionalities, privileges } from '@/shared/services/AuthService';
import HasFeature from '@/shared/components/security/HasFeature';

const TaskListGlobalActionsButton = props => {
  const {
    intl,
    disabled,
    onChangedAssignedUser,
    onDeleteTask,
    onChangeDeadline,
    onChangeExecutionDate,
    onAddTaskTags,
    onRemoveTaskTags,
    onSendEmail,
    hasTodos,
    hasTasks,
  } = props;

  const { canUpdateTasks, canUpdateTodo, canDeleteTasks, canDeleteTodo } = useMemo(
    () => ({
      canUpdateTasks:
        hasTasks &&
        AuthService.hasPermission({
          functionality: functionalities.PlannedTask,
          privilege: privileges.Update,
        }),
      canUpdateTodo:
        hasTodos &&
        AuthService.hasPermission({
          functionality: functionalities.Todo,
          privilege: privileges.Update,
        }),
      canDeleteTasks:
        hasTasks &&
        AuthService.hasPermission({
          functionality: functionalities.PlannedTask,
          privilege: privileges.Delete,
        }),
      canDeleteTodo:
        hasTodos &&
        AuthService.hasPermission({
          functionality: functionalities.Todo,
          privilege: privileges.Delete,
        }),
    }),
    [hasTasks, hasTodos],
  );

  if (!canUpdateTasks && !canUpdateTodo && !canDeleteTasks && !canDeleteTodo) return null;

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.TaskGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        {canUpdateTasks || canUpdateTodo ? (
          <>
            <MenuItem onSelect={onChangedAssignedUser} disabled={disabled}>
              {intl.formatMessage(messages.ChangeAssignedUser)}
            </MenuItem>
            <MenuItem onSelect={onChangeDeadline} disabled={disabled}>
              {intl.formatMessage(messages.ChangeDeadline)}
            </MenuItem>
            <HasFeature feature={'CapacityPlanning'}>
              <MenuItem onSelect={onChangeExecutionDate} disabled={disabled}>
                {intl.formatMessage(messages.ChangeExecutionDate)}
              </MenuItem>
            </HasFeature>
            <MenuItem onSelect={onSendEmail} disabled={disabled}>
              {intl.formatMessage(messages.SendEmail)}
            </MenuItem>
            <MenuItem onSelect={onAddTaskTags} disabled={disabled}>
              {intl.formatMessage(messages.AddTaskTags)}
            </MenuItem>
            <MenuItem onSelect={onRemoveTaskTags} disabled={disabled}>
              {intl.formatMessage(messages.RemoveTaskTags)}
            </MenuItem>
          </>
        ) : null}
        {canDeleteTasks || canDeleteTodo ? (
          <MenuItem onSelect={onDeleteTask} disabled={disabled}>
            {intl.formatMessage(messages.DeleteTask)}
          </MenuItem>
        ) : null}
      </DropdownButton>
    </span>
  );
};

TaskListGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
  onChangedAssignedUser: PropTypes.func.isRequired,
  onChangeDeadline: PropTypes.func.isRequired,
  onChangeExecutionDate: PropTypes.func.isRequired,
  onDeleteTask: PropTypes.func.isRequired,
  onAddTaskTags: PropTypes.func.isRequired,
  onRemoveTaskTags: PropTypes.func.isRequired,
  onSendEmail: PropTypes.func.isRequired,
};
TaskListGlobalActionsButton.defaultProps = {
  disabled: false,
};
export default injectIntl(TaskListGlobalActionsButton);
